var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.036)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 330",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(-.036)",
    style: {
      fill: "#258fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 15311"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7283",
    d: "m0 9.315 5.1-5.1 5.1 5.1",
    transform: "translate(8 2.783)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7284",
    d: "M3.924 5.457v10.2",
    transform: "translate(9.174 3.242)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic-send.544a77e8f46ce2e41ca2fcd1e686a0bd.svg";
export { ForwardRef as ReactComponent };